import { render, staticRenderFns } from "./casNotify.vue?vue&type=template&id=3a04b6bc"
import script from "./casNotify.vue?vue&type=script&lang=js"
export * from "./casNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports